import './index.erb';
import './index.rb';
import 'plyr/dist/plyr.css';
import Plyr from 'plyr';

$(function () {
  const $modal = $('#js-question-answer-modal');
  const player = new Plyr($($modal.find('video')), {
    controls: []
  });

  let progressInterval;

  // open modal
  $modal.on('shown.bs.modal', () => {
    setTimeout(() => {
      player.play();
    }, 100);
  });

  // close modal
  $modal.on('hidden.bs.modal', () => {
    player.stop();

    if (progressInterval) {
      clearInterval(progressInterval);
      progressInterval = null;
    }
  });

  let watchedTime = 0;
  const totalRequiredTime = 10;

  player.on('play', () => {
    $modal.find('#js-question-answer-modal-close').attr('disabled', true);

    if (progressInterval) {
      clearInterval(progressInterval);
    }

    const updateInterval = 100;

    progressInterval = setInterval(() => {
      watchedTime += updateInterval / 1000;

      const currentProgress = Math.min(
        (watchedTime / totalRequiredTime) * 100,
        100
      );

      if (currentProgress >= 100) {
        $modal.find('.progress-bar').css('width', '100%');
        $modal.find('#js-question-answer-modal-close').removeAttr('disabled');
        clearInterval(progressInterval);
        progressInterval = null;
      } else {
        $modal.find('.progress-bar').css('width', `${currentProgress}%`);
      }
    }, updateInterval);
  });

  player.on('pause', () => {
    if (progressInterval) {
      clearInterval(progressInterval);
      progressInterval = null;
    }
  });
});
